import { render, staticRenderFns } from "./WidgetButton.vue?vue&type=template&id=b0a0f91c"
import script from "./WidgetButton.vue?vue&type=script&lang=js"
export * from "./WidgetButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports